import httpClient from './httpClient';
import type { ImportResult } from '@/types/inventory';

function mdCreateFormData(mdFile: File): FormData {
  const mdFormData = new FormData();
  mdFormData.append('file', mdFile);
  return mdFormData;
}

export async function importProducts(mdFile: File): Promise<ImportResult> {
  const mdFormData = mdCreateFormData(mdFile);
  const mdResponse = await httpClient.post<ImportResult>(
    '/import/products',
    mdFormData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return mdResponse.data;
}

export async function importSuppliers(mdFile: File): Promise<ImportResult> {
  const mdFormData = mdCreateFormData(mdFile);
  const mdResponse = await httpClient.post<ImportResult>(
    '/import/suppliers',
    mdFormData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return mdResponse.data;
}

export async function importCustomers(mdFile: File): Promise<ImportResult> {
  const mdFormData = mdCreateFormData(mdFile);
  const mdResponse = await httpClient.post<ImportResult>(
    '/import/customers',
    mdFormData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return mdResponse.data;
}
